<template>
    <div>
        <reg-base-header-sec></reg-base-header-sec>
        <!--        <div class="container-fluid base-container">-->
        <!--            <div class="base-box p-normal">-->
        <!--                RegLatestPage-->
        <!--                {{regList}}-->
        <!--            </div>-->

        <!--        </div>-->

        <div class="container-fluid base-container">
            <div class="base-box base-box__table-sec">
                <table class="table  table-striped table-sm table-slglrs">
                    <tr v-for="(item, index) in regList" v-bind:key="index">
                        <td>
                            <router-link v-if="item.url !== null && item.url !== ''" class="color-link d-block"
                                target="_blank" :to="{ path: 'viewAct/' + item.url }">
                                <span class="text">{{ item.name }}</span>
                            </router-link>
                            <router-link v-else :to="'viewPdf/' + item.regId" target="_blank">
                            {{ data.item.title }} </router-link>
                        </td>
                    </tr>
                </table>

                <!--                <div class="mb-4" v-for="(item, index) in regList" v-bind:key="index">-->
                <!--                    <a class="color-link text-85" :href="baseApiUrl+ 'reg/viewAct/'+item.url" target="_blank">{{item.name}}</a>-->
                <!--                </div>-->
            </div>
        </div>
    </div>
</template>

<script>
import RegBaseHeaderSec from '@/base_pages/reg/RegBaseHeaderSec.vue';
import axios from 'axios';

export default {
    name: "RegLatestPage",
    data() {
        return {
            regList: [],
            baseApiUrl: window.env.VUE_APP_API_REG_DEV,
            meta: {
                title: 'Правно-информациони систем РС',
                description: 'Правно-информациони систем je збирка података у електронском облику која садржи: електронски облик Службеног гласника, архиву службених гласила, базу која садржи регистар и текстове важећих прописа и других аката Републике Србије објављених у Службеном гласнику, базу која садржи судску праксу, друге податке о правном систему Републике Србије и везу с правним актима Европске уније.',
                keywords: 'zakoni, akti, zakonski, propisi, sudska praksa, registar, odluka, sudovi, ugovori, pravno informacioni sistem, prins, pis,sluzbeni glasnik',
            },

        }
    },
    metaInfo() {
        return {
            title: this.meta.title,
            meta: [
                { name: 'title', content: this.meta.title },
                { name: 'description', content: this.meta.description },
                { name: 'keywords', content: this.meta.keywords },
            ],
        }
    },
    components: {
        RegBaseHeaderSec,
    },
    methods: {
        fetchData() {

            axios
                .get(this.baseApiUrl + 'latestActs')

                .then(response => {
                    console.log(response);
                    this.regList = response.data;
                }).catch(function (error) {
                    console.log(error);
                });
        },
    },
    mounted() {
        this.fetchData();
    },
    beforeCreate: function () {
        document.body.className = 'color_reg';
    }
}
</script>

<style scoped></style>
